import React from 'react';

import { H3, P, useInvertedLocalize } from '../../../utilities';
import { type FactorType } from '../models';

import loginMethods from './loginMethods';
import { invertedMessages } from './messages';

import './FactorCard.css';

interface FactorCardProps {
  item: FactorType;
  onSelect: (factor: FactorType) => void;
}

/** This is to display all the factors the user has enrolled in for verification of their identity */
export default function FactorCard({
  item,
  onSelect,
}: FactorCardProps): JSX.Element {
  const { icon: Icon, title, description } = useContent(item);
  const handleClick = () => onSelect(item);

  return (
    <button className='Nav_FactorCard' onClick={handleClick} type='button'>
      <div className='Nav_FactorCard-icon'>
        <Icon />
      </div>
      <div className='Nav_FactorCard-content'>
        <H3 className='Nav_FactorCard-content-title'>{title}</H3>
        <P variant={2} className='Nav_FactorCard-content-description'>
          {description}
        </P>
      </div>
    </button>
  );
}

function useContent(factor: FactorType) {
  const l = useInvertedLocalize(invertedMessages);

  if (factor === 'test') {
    return loginMethods[factor];
  }

  const { icon, title, description } = loginMethods[factor];

  return { icon, title: l(title), description: l(description) };
}
